<template>
  <!-- Content Left Rail -->
  <v-sheet class="settings-left-nav">
    <v-list-item-title class="settings-nav-title font-weight-medium"
      >Calls</v-list-item-title
    >
    <v-list dense nav>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('call-uniq-cust')"
        @click="navigateTo('call-uniq-cust')"
      >
        Unique Customers
      </v-list-item>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('call-log')"
        @click="navigateTo('call-log')"
      >
        Call Log
      </v-list-item>
      <v-list-group :value="showSettings" no-action>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item class="subtitle-1 left-nav-group-title"
              >Settings</v-list-item
            >
          </v-list-item-content>
        </template>
        <v-list-item
          class="subtitle-1 left-nav-group"
          :class="routeColor('telecom-flow')"
          @click="navigateTo('telecom-flow')"
          v-if="$root.$children[0].isAdmin"
        >
          Call Flows
        </v-list-item>
        <v-list-item
          class="subtitle-1 left-nav-group"
          :class="routeColor('telecom-fwd')"
          @click="navigateTo('telecom-fwd')"
          v-if="$root.$children[0].isAdmin"
        >
          Forwarding Numbers
        </v-list-item>
        <v-list-item
          class="subtitle-1 left-nav-group"
          :class="routeColor('telecom-trck')"
          @click="navigateTo('telecom-trck')"
          v-if="$root.$children[0].isAdmin"
        >
          Tracking Numbers
        </v-list-item>
        <v-list-item
          class="subtitle-1 left-nav-group"
          :class="routeColor('telecom-block')"
          @click="navigateTo('telecom-block')"
          v-if="$root.$children[0].isAdmin"
        >
          Call/Text Blocking
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-sheet>
</template>

<script>
export default {
  name: "CallLeftNavigation",
  props: {
    msg: String
  },
  data: function() {
    return {
      toggleFilter: 1,
      selectedItem: null,
      showSettings: false
    };
  },
  created() {},
  watch: {},
  computed: {},
  methods: {
    navigateTo(settingType) {
      this.$parent.$parent.$parent.settingsNavSelected = settingType;
      this.$root.$children[0].navMenuOpen = false;
    },
    routeColor(routeName) {
      return this.$parent.$parent.$parent.settingsNavSelected == routeName
        ? "font-weight-medium"
        : "font-weight-normal";
    }
  }
};
</script>

<style scoped lang="stylus">
.settings-left-nav {
  padding-top: 1rem;
}

div.settings-left-nav, div.settings-left-nav div {
  background-color: rgb(241, 241, 241);
  width: 100%;
}
div.settings-left-nav div {
  background-color: rgba(241, 241, 241, 0);
}
.settings-left-nav div.v-list {
  padding: 0;
}
.settings-nav-title {
  padding: 1.5rem 2rem 0.5rem;
  font-size: 1.1rem;
  font-weight: 500;
  text-transform: uppercase;
}
.subtitle-1 {
  font-size: 1rem;
  font-weight: 400;
}
.v-list-item.left-nav {
  padding: .5rem 2rem;
}
div.v-list-group div.v-list-item.left-nav-group {
  padding: .5rem 3rem !important;
}
.v-list-item.left-nav-group-title {
  padding: .5rem 1.5rem;
}
</style>
